import { inject } from "@angular/core";
import { DynamicImportService } from "@app/core/services/dynamic-import/dynamic-import.service";
import { PaymentService } from "@app/core/services/payment/payment.service";
import { BaseWidget } from "@app/widgets/base-widget/base-widget";

export class RazorpayPaymentHandler {
  private readonly mPaymentService = inject(PaymentService);
  dialog:any
  dyis:DynamicImportService
  constructor(partial: Partial<RazorpayPaymentHandler>) {
    Object.assign(this, partial);
  }

  async handle(initPaymentInfo: any) {
    await this.mPaymentService.processPayment(initPaymentInfo);
  }
}
